import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'

import Layout from '../../App/layout'
import ContentLayout from '../../../components/utility/layoutContent'
import LayoutContentWrapper from '../../../components/utility/layoutWrapper'
import CompanyAddOrderContainer from './CompanyAddOrderContainer'
import { COMPANY_NAME_QUERY } from '../detail/queries'

const CompanyNewOrderPage = ({ location, match }) => {
    const { id } = match.params

    useEffect(() => { document.title = 'Add Order | OSH CRM' }, [])

    const { data } = useQuery(COMPANY_NAME_QUERY, { variables: { id } })
    const companyName = (data && data.company && data.company.name) ||
        (location.params && location.params.number) || 'บริษัท'

    return (
        <Layout>
            <LayoutContentWrapper breadcrumbs={[
                { path: '/customers', name: 'ลูกค้าและบริษัท' },
                { path: `/companies/${id}`, name: companyName },
                { path: `/companies/${id}/orders/new`, name: 'เพิ่มออเดอร์' }
            ]}>
                <ContentLayout>
                    <CompanyAddOrderContainer companyId={id} />
                </ContentLayout>
            </LayoutContentWrapper>
        </Layout>
    )
}

export default CompanyNewOrderPage
